/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_EnableInputs */



/**
* | output |
* | --- |
* | "Enable Foot Pedal Control" |
*
* @param {Options_Pedal_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_enable = /** @type {((inputs?: Options_Pedal_EnableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_EnableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer le contrôle par pédale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fußpedalsteuerung aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita il controllo del pedale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить управление с помощью ножной педали")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar el control del pedal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用脚踏板控制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フットペダルコントロールを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ुट पेडल नियंत्रण सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar o controle por pedal")
	return /** @type {LocalizedString} */ ("Enable Foot Pedal Control")
});